export * from './reservation-priority.model';
export * from './reservation-priority-popup.service';
export * from './reservation-priority.service';
export * from './reservation-priority-dialog.component';
export * from './reservation-priority-delete-dialog.component';
export * from './reservation-priority-detail.component';
export * from './reservation-priority.component';
export * from './reservation-priority.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-priority/index.ts